import React from 'react';
import { Container, Paper, Typography, Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">Labourando Privacy Policy</Typography>
        <Typography variant="body2" paragraph>Effective date: 10 March 2026</Typography>

        <Typography variant="h6" gutterBottom>1. Overview</Typography>
        <Typography variant="body1" paragraph>This Privacy Policy explains how Labourando collects, uses, stores, shares and protects personal information in connection with the Service. By using Labourando you consent to the practices described in this policy.</Typography>

        <Typography variant="h6" gutterBottom>2. Information We Collect</Typography>
        <Typography variant="body1" paragraph>
          - Account and profile information: name, phone number, email (if provided), address, and other profile fields.<br/>
          - Documents: uploaded identity or verification documents supplied by users for verification purposes.<br/>
          - Usage data: logs, device and browser information, IP addresses, and activity within the Service.
        </Typography>

        <Typography variant="h6" gutterBottom>3. How We Use Information</Typography>
        <Typography variant="body1" paragraph>
          - To provide and improve the Service, authenticate users, and facilitate job matching.<br/>
          - To share user profile information and uploaded documents with Companies when a Job Seeker applies for a job or otherwise consents to sharing.<br/>
          - To send administrative communications, security alerts, and transactional messages.
        </Typography>

        <Typography variant="h6" gutterBottom>4. Consent and Sharing</Typography>
        <Typography variant="body1" paragraph>By creating a profile and applying for jobs, Job Seekers consent to the sharing of their profile data and uploaded documents with Companies that post jobs. Companies are responsible for how they store and secure any personal information received.</Typography>

        <Typography variant="h6" gutterBottom>5. Data Retention</Typography>
        <Typography variant="body1" paragraph>We retain personal information for as long as necessary to provide the Service, comply with legal obligations, resolve disputes, and enforce agreements. Retention periods vary by data type and legal need.</Typography>

        <Typography variant="h6" gutterBottom>6. Security</Typography>
        <Typography variant="body1" paragraph>We use industry-standard administrative, technical and physical safeguards to protect personal information. However, no system is completely secure. Companies that receive user data are independently responsible for securing it.</Typography>

        <Typography variant="h6" gutterBottom>7. Third Parties</Typography>
        <Typography variant="body1" paragraph>We may share data with service providers (hosting, analytics, email), and with Companies when users apply for or accept job offers. We do not sell personal information to third parties.</Typography>

        <Typography variant="h6" gutterBottom>8. Your Rights</Typography>
        <Typography variant="body1" paragraph>Subject to applicable law, you may have rights to access, correct, port, or delete your personal information, or object to certain processing. Contact support to exercise your rights.</Typography>

        <Typography variant="h6" gutterBottom>9. International Transfers</Typography>
        <Typography variant="body1" paragraph>Data may be transferred to, stored, and processed in countries outside your country of residence. When transfers occur we adopt safeguards to protect data in accordance with applicable law.</Typography>

        <Typography variant="h6" gutterBottom>10. Children</Typography>
        <Typography variant="body1" paragraph>Our Service is not directed at children under 16. We do not knowingly collect personal information from children under 16.</Typography>

        <Typography variant="h6" gutterBottom>11. Changes</Typography>
        <Typography variant="body1" paragraph>We may update this Privacy Policy. We will publish changes with an updated effective date.</Typography>

        <Box sx={{ mt: 2 }}>
          <Link component={RouterLink} to="/" color="primary">Back to Home</Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicyPage;
